import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import PackageStandardWrap from "./PackageStandardWrap";

function PackageStandard() {
  return (
    <>
      <Breadcrumb name="Package Standard" />
      <PackageStandardWrap />
    </>
  );
}

export default PackageStandard;
